import { render } from "./DropdownButton.vue?vue&type=template&id=95e3dad0&ts=true"
import script from "./DropdownButton.vue?vue&type=script&lang=ts"
export * from "./DropdownButton.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__